export const NAVBAR_HEIGHT = 40
